// Librairies
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

// Classes
import { Pop } from 'src/app/classes/shared/pop';

// Components
import { ButtonComponent, CustomInputEditorComponent, KeyValue } from 'ui-library';


@Component({
  selector: 'app-metric-editor',
  imports: [
    TranslateModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatSelectModule,
    MatToolbarModule,
    ButtonComponent,
    CustomInputEditorComponent
  ],
  templateUrl: './metric-editor.component.html',
  styleUrl: './metric-editor.component.scss',
  standalone: true
})

export class MetricEditorComponent {
  // Services
  public readonly data: any = inject(MAT_DIALOG_DATA);
  private readonly dialogRef: MatDialogRef<KeyValue> = inject(MatDialogRef);
  private readonly tools: Pop = inject(Pop);
  private readonly translate: TranslateService = inject(TranslateService);

  // Variables
  metric: any = {
    name: "",
    payload: [{
      label: "startDate",
      value: "",
      options: [],
      newOption: "",
      isDefault: true,
      type: "date"
    }, {
      label: "title",
      value: "",
      options: [],
      newOption: "",
      isDefault: true,
      type: "text"
    }]
  };

  templates: any = {
    weight: {
      label: "weight",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "number",
      icon: "fitness_center"
    },
    endDate: {
      label: "endDate",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "date",
      icon: "event"
    },
    crane: {
      label: "crane",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "text",
      icon: "build"
    },
    color: {
      label: "color",
      value: "#FF0000",
      options: [],
      newOption: "",
      isDefault: false,
      type: "text",
      icon: "palette"
    },
    tracker: {
      label: "tracker",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "text",
      icon: "pin_drop"
    },
    unit: {
      label: "unit",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "text",
      icon: "pin_drop"
    },
    durationTime: {
      label: "durationTime",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "number",
      icon: "timer"
    },
    comment: {
      label: "comment",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "text",
      icon: "info"
    },
    weightTotal: {
      label: "weightTotal",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "number",
      icon: "fitness_center"
    },
    distance: {
      label: "distance",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "number",
      icon: "360"
    },
    concreteWeight: {
      label: "concreteWeight",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "number",
      icon: "save_alt"
    },
    volume: {
      label: "volume",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "number",
      icon: "water_drop"
    },
    concretings: {
      label: "concretings",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "number",
      icon: "construction"
    },
  };

  templateNames: string[] = Object.keys(this.templates).sort();

  filteredTemplates = Object.keys(this.templates)
    .sort()
    .map((key) => ({
      name: key,
      icon: this.templates[key].icon
    }));

  constructor() {
    if (this.data.name) {
      this.metric = { ...this.data }
    } else { }
    this.metric.payload.forEach((p: any) => {
      p.newOption = "";
    })
  }

  saveMetric() {
    if (this.metric.name) {
      this.metric.payload = this.metric.payload.filter((p: any) => p.label)

      this.metric.payload.forEach((p: any) => {
        delete p.newOption;
      })

      this.tools.toast(this.translate.instant("trackers.edit_success"), "success", 4000, "save");
      this.dialogRef.close(this.metric);
    } else {
      this.tools.error(this.translate.instant("settings.project.errNameTemplate"));
    }
  }

  addPayload() {
    this.metric.payload.push({
      label: "",
      value: "",
      options: [],
      newOption: "",
      isDefault: false,
      type: "text"
    })

  }

  deletePayload(index: number) {
    this.metric.payload.splice(index, 1)
  }

  addTemplatePayload(templateName: string) {
    const index = this.metric.payload.findIndex((item: KeyValue) => item.key === templateName);
    if (index !== -1)
      return;

    this.metric.payload.push({ ...this.templates[templateName] });
  }
  close() {
    this.dialogRef.close();
  }
}
